import sha1 from "simple-sha1";
import type { Media } from "../schema/Media.js";
import type { UploadedFileBucket } from "../schema/UploadedFileBucket.js";

export function thumbUploadedFile(
	width: number,
	height: number,
	image: Media,
	bucketUrlMap: Record<UploadedFileBucket, string>,
	format: "webp" | null = "webp",
): string {
	const bucketUrl = bucketUrlMap[image.bucket];
	let newPath = typeof image === "string" ? image : image.path;
	if (format !== null) {
		newPath += `.${format}`;
	}
	const url = new URL(newPath, bucketUrl);
	url.pathname = `/${width}x${height}${url.pathname}`;
	return `${url.toString()}?hash=${sha1.sync(url.pathname.replace("/", ""))}`;
}
